import React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import {
    BAM_LICENSES_ROUTE,
    deriveRedirectTarget,
    detectApplicationFromPath,
    LICENSES_ROUTE,
} from "components/router/Routes";
import { Application } from "store/application";

export default function LicensesView(): JSX.Element {
    const { pathname } = useLocation();
    const isRouteEnabled = useIsRouteEnabled();

    const route = detectApplicationFromPath(pathname) === Application.BAM ? BAM_LICENSES_ROUTE : LICENSES_ROUTE;
    const target = deriveRedirectTarget(route, isRouteEnabled);

    return <Redirect to={target.path} />;
}
